export const JSON_API_BULK_HEADERS: Record<string, string> = {
  'Content-Type': 'application/vnd.api+json; ext=bulk',
};
